module.exports = __webpack_public_path__ + "static/media/sliced_salted_cucumbers.0aa6d05f.png";